import { WellWish } from "../../types/wellwish";
import { generateAPI } from "../api.generator";

export const getTextAndGifWellWishes = generateAPI<
  {
    query: {
      page: number;
      search?: string;
      creationCtx?: "wellwish" | "lovewall";
      limit?: number;
    };
  },
  {
    wellWishesCount: number;
    wellWishes: WellWish[];
  }
>("get", "well-wish/text-and-gif/all");
